import { Venue as VenueModel } from '@models/Venue'
import { useAppSelector } from '@store/hooks'
import { selectVenueById } from '@store/VenueReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { ConditionalWrapper } from '@supplement-bacon/react-toolkit/utils'
import { Permission } from '@utils/permissions'
import { Avatar, Space, Tooltip, Typography } from 'antd'
import { AvatarProps } from 'antd/es/avatar'
import { Link } from 'react-router-dom'
import { useHasAccess } from '../HasAccess'
import { Venue } from './Venue'

const { Text } = Typography

type Props = SBModelComponent<VenueModel> & {
  size?: AvatarProps['size']
  type?: 'full' | 'condensed'
  linkToDetails?: 'avatar' | 'name'
}

export const VenueAvatar = ({
  id,
  model,
  size = 'default',
  type = 'full',
  linkToDetails = 'avatar',
}: Props) => {
  const venue = model ? model : useAppSelector(selectVenueById(id!))
  const { hasAccess } = useHasAccess()

  if (!venue) {
    return <></>
  }

  return (
    <ConditionalWrapper
      condition={linkToDetails === 'avatar' && hasAccess(Permission.readVenue)}
      wrapper={(children) => (
        <Link to={`/venues/${venue.slug}/overview`}>{children}</Link>
      )}
    >
      <Space orientation="horizontal">
        <Tooltip title={venue.name} open={type == 'full' ? false : undefined}>
          <Avatar
            src={venue.logo ? venue.logo.url : undefined}
            shape="square"
            size={size == 'large' ? 60 : size}
            style={{
              color: '#fff',
              fontSize: size == 'small' ? 11 : undefined,
            }}
          ></Avatar>
        </Tooltip>
        {type == 'full' && (
          <Space.Compact orientation="vertical">
            <Space orientation="horizontal">
              <ConditionalWrapper
                condition={
                  linkToDetails === 'name' && hasAccess(Permission.readVenue)
                }
                wrapper={(children) => (
                  <Link to={`/venues/${venue.slug}/generals`}>{children}</Link>
                )}
              >
                <Text>{venue.name}</Text>
              </ConditionalWrapper>
            </Space>
            {venue.address && <Venue.Address model={venue} />}
          </Space.Compact>
        )}
      </Space>
    </ConditionalWrapper>
  )
}

export type VenueAvatarType = { Avatar: typeof VenueAvatar }
